import { create } from "zustand";

import { Permission, IPermissionAction } from "@/models";

import { OrionV2AuthenticateResponseT } from "../services/orionv2";

type PermissionsStoreT = {
  sessionLocalId: string | undefined;
  isSignedIn: boolean;
  isAdmin: boolean;
  accessLevel: string;
  userName: string;
  actionsAllowed: IPermissionAction[];
  startSession: (user: OrionV2AuthenticateResponseT) => void;
  clearSession: () => void;
  isAllowedTo: (permissions: Permission[], exhaustive?: boolean) => boolean;
};

const include = (permissions: IPermissionAction[], toCheck: IPermissionAction): boolean => {
  return permissions.some((p) => p === toCheck);
};

export const usePermissions = create<PermissionsStoreT>()((set, get) => ({
  sessionLocalId: undefined,
  accessLevel: "",
  userName: "",
  isSignedIn: false,
  isAdmin: false,
  actionsAllowed: [],
  startSession: (user: OrionV2AuthenticateResponseT) => {
    set({
      sessionLocalId: (Math.random() * 10000).toString(),
      accessLevel: user.accessLevel,
      userName: user.userName,
      isAdmin: user.accessLevel === "Admin",
      isSignedIn: true,
      actionsAllowed: user.actions,
    });
  },
  clearSession: () => {
    set({
      sessionLocalId: undefined,
      accessLevel: "",
      userName: "",
      actionsAllowed: [],
      isSignedIn: false,
    });
  },
  isAllowedTo: (permissions: IPermissionAction[], exhaustive?: boolean) => {
    // Por ahora el admin queda sin el super permiso (workitems: #114868)
    // if (get().isAdmin) {
    //   return true;
    // }
    return exhaustive
      ? permissions.every((permission) => include(get().actionsAllowed, permission))
      : permissions.some((permission) => include(get().actionsAllowed, permission));
  },
}));
